<app-dialog-base class="modalcontaineraccess" *ngIf="isDialogVisible" [dialogId]="dialogId"
  [Title]="(dialogMode === DialogMode.Create ? 'Create container' : 'Edit container') | translate" [width]="'940px'" [height]="'720px'"
  (onClose)="closeDialog()">
  <div class="dialog-body">
    <div class="container-editor">
      <div class="container-editor-body">
        <div class="inputgroup" style="width: 100%;">
          <label>{{'Name'|translate}}</label>
          <input type="text" [(ngModel)]="draftContainerName" [readonly]="!canEditContainerName()" />
        </div>
        <div class="validation" *ngIf="nameTouched && !(draftContainerName || '').trim()">
          {{'The name field is required'|translate}}
        </div>

        <div class="access-body">
          <div class="users-panel">
            <div class="inputgroup container-users-controls">
              <label>{{'Users'|translate}}</label>
              <button class="btnadd" style="padding-left: 20px;" type="button" (click)="openUsersPicker()" [disabled]="!canManageMembers()"></button>
            </div>

            <div class="filter-row">
              <input class="searchinput" type="text" placeholder="{{'Search'|translate}}" [(ngModel)]="searchTerm" />
            </div>

            <div class="users-list">
              <div class="user-item" *ngFor="let item of filteredUsers"
                [class.active]="selectedUser?.userId == item.userId" (click)="selectUser(item)">
                <div class="user-text">
                  <div class="username" [title]="item.name">{{!item.name ? '****' : item.name}}</div>
                  <div class="useremail" *ngIf="item.companyId" [title]="getCompanyName(item.companyId)">
                    {{getCompanyName(item.companyId)}}
                  </div>
                </div>
                <button class="btn_img btn_trush" *ngIf="canRemoveUser(item)" type="button"
                  (click)="removeUser(item, $event)"></button>
                <div *ngIf="!canRemoveUser(item)"></div>
              </div>
            </div>

            <div class="empty-users" *ngIf="filteredUsers.length == 0">
              {{'No users in container'|translate}}
            </div>
          </div>

          <div class="rights-panel" *ngIf="selectedUser">
            <div class="rights-header">
              <div class="tableheader">{{'Access rights for'|translate}} {{selectedUser.name}}</div>
            </div>

            <div class="presets-row">
              <span class="presets-title">{{'Presets of access rights'|translate}}</span>
              <button class="btn_preset" *ngFor="let preset of aclPresets"
                [class.active]="activePresetMask === preset.mask" (click)="applyPreset(preset.mask)"
                [disabled]="!canEditUserAcl(selectedUser)">
                {{preset.label | translate}}
              </button>
            </div>

            <div class="acl-groups">
              <div class="acl-group" *ngFor="let group of aclGroups">
                <div class="acl-group-title">{{group.title | translate}}</div>
                <div class="acl-grid">
                  <label class="acl-item" *ngFor="let acl of group.items">
                    <input type="checkbox"
                      [disabled]="!canEditUserAcl(selectedUser) || !canManageMembers() || !isAclAllowed(acl.value)"
                      [checked]="isAclSet(selectedUser, acl.value)"
                      (change)="onAclChange(selectedUser, acl.value, $event)" />
                    <span>{{acl.label | translate}}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="rights-panel empty-users" *ngIf="!selectedUser">
            {{'Select user'|translate}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div rightFooterColumn class="dialog-footer">
    <button class="btn_blue" type="button" (click)="saveDialog()" [disabled]="!canSave()">
      {{(dialogMode === DialogMode.Create ? 'Create container' : 'Apply') | translate}}
    </button>
    <button class="btn_lgray" type="button" (click)="closeDialog()">{{'Close'|translate}}</button>
  </div>
</app-dialog-base>

<template #usersListDialog></template>
